<app-loading *ngIf="isLoading"></app-loading>
<app-modal *ngIf="!isLoading">
  <app-modal-header
    [title]="T.common.add_item | translate: { item: localisedTask }"
    [showDelete]="false"
    (closed)="confirmClose()">
  </app-modal-header>
  <!-- Validation Errors -->
  <div class="validations-erros-container" *ngIf="validationErrors?.length > 0">
    <div class="validation-error" *ngFor="let error of validationErrors">
      <i class="material-symbols-outlined">error_outline</i>
      {{ error }}
    </div>
  </div>

  <app-modal-body>
    <div [formGroup]="form">
      <section class="row col-row-space custom-gutters section-padding">
        <div class="container-with-bottom-element col-md-12 col-12">
          <app-filter-dropdown-new
            [displayError]="triggerErrors"
            [filterByModuleObjectType]="false"
            [filterType]="filterTypes.Project"
            [disableMargin]="true"
            [required]="true"
            [disabled]="disableProjectsDropdown"
            [singleSelect]="true"
            [appliedFilters]="filters"
            [typeahead]="true"
            [currentlySelectedSettingValue]="selectedProject?.filterValue"
            (onFilterUpdate)="handleProjectChange($event)"
            [label]="localisedProject + '*'">
          </app-filter-dropdown-new>
        </div>

        <div class="col-md-12 col-12">
          <app-filter-dropdown-new
            [filterByModuleObjectType]="false"
            [disabled]="disableTaskGroupDropdown"
            class="flex-fill modal-taskgroup"
            [filterType]="filterTypes.Task_Group"
            [disableMargin]="true"
            [singleSelect]="true"
            [appliedFilters]="filters"
            [typeahead]="true"
            [currentlySelectedSettingValue]="selectedTaskGroup?.filterValue"
            (onFilterUpdate)="handleFilterChange($event)"
            [relatedObjectId]="selectedProject?.filterValue">
          </app-filter-dropdown-new>
        </div>
        <div class="col-md-12 col-12">
          <app-text-field
            [autofocus]="true"
            [displayError]="triggerErrors"
            [required]="true"
            class="flex-fill modal-task"
            formControlName="taskTitle"
            [useReactiveMessages]="true"
            [disableMargin]="true"
            [svg]="taskSvg"
            [placeholder]="(T.common.item_title | translate: { item: localisedTask }) + '*'"
            [formGroup]="form"
            [maxLength]="250">
          </app-text-field>
        </div>
        <div class="col-md-12 col-12">
          <app-text-field
            name="headlineStatus"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="task.headlineStatus"
            [placeholder]="T.defaultLocalizations.headline_status.one | translate"
            [maxLength]="255"
            [minLength]="3"
            [required]="false">
          </app-text-field>
        </div>
        <div class="col-md-8 col-12 d-flex" *ngIf="!dateReseter">
          <app-datepicker
            class="nested-col-left"
            [required]="mandatoryDates"
            [disabled]="isMilestoneActivated"
            [showError]="triggerErrors"
            [showHeader]="true"
            [showFooter]="false"
            [range]="true"
            [endDate]="getDueDate"
            [date]="getStartDate"
            (dateChanged)="setStartDate($event)"
            (endDateChanged)="setDueDate($event)"
            [placeholder]="T.common.start_date.one | translate"
            [showPlaceholderFirst]="true"
            [disableMargin]="true">
          </app-datepicker>
          <app-datepicker
            class="nested-col-right"
            [required]="mandatoryDates"
            [showError]="triggerErrors"
            [showFooter]="false"
            [showHeader]="true"
            [range]="true"
            [endDate]="getDueDate"
            [date]="getStartDate"
            [isEndDateField]="true"
            (dateChanged)="setStartDate($event)"
            (endDateChanged)="setDueDate($event)"
            [placeholder]="T.defaultLocalizations.due_date.one | translate"
            [showPlaceholderFirst]="true"
            [disableMargin]="true">
          </app-datepicker>
        </div>
        <div class="col-md-4 col-12">
          <app-filter-dropdown-new
            [useSearch]="false"
            [currentlySelectedSettingValue]="selectedRag?.filterValue"
            [displayError]="triggerErrors"
            [required]="true"
            [disableMargin]="true"
            [filterByModuleObjectType]="false"
            [disabled]="disableRagDropdown"
            [filterType]="filterTypes.RAG"
            [singleSelect]="true"
            [appliedFilters]="filters"
            [typeahead]="true"
            [label]="(T.common.rag_status.one | translate) + '*'"
            (onFilterUpdate)="handleFilterChange($event)">
          </app-filter-dropdown-new>
        </div>
      </section>
    </div>

    <app-accordion-details [collapsing]="false" [emphasizedHeaders]="true">
      <app-accordion-item-details [title]="T.common.details | translate" [expanded]="false">
        <ng-template accordionContent>
          <section class="row col-row-space custom-gutters section-padding">
            <div class="col-12">
              <app-filter-dropdown-new
              [useSearch]="false"
              [filterByModuleObjectType]="false"
              [filterType]="filterTypes.Milestone_Type"
              [singleSelect]="true"
              [appliedFilters]="filters"
              [typeahead]="true"
              [label]="T.common.milestone.one | translate"
              [disableMargin]="true"
              (onFilterUpdate)="handleMilestoneChange($event)">
              </app-filter-dropdown-new>
            </div>
            <div class="col-12">
              <div class="rating-star-container">
                <div class='priority-starts-container text-center w-100' >
                  <app-priority
                    [selectedPriority]="currentSelectedPriorityFilter"
                    [showSelectPriorityLabel]="true"
                    (priorityChanged)="onApply($event)"
                    [filterType]="filterTypes.Task_Priority" >
                  </app-priority>
                </div>
              </div>
            </div>
            <div class="col-12">
              <app-simple-dropdown
                (objectSelected)="handleCompletion($event)"
                [objects]="completionArr"
                bindProperty="visibleValue"
                [label]="T.common.completion | translate">
              </app-simple-dropdown>
            </div>
            <div class="description col-12">
              <app-details-editable-field
                [input]="form.controls.description.value ? form.controls.description.value : ''"
                [header]="T.defaultLocalizations.description.one | translate"
                [type]="editableFieldTypes.RichText"
                [canEdit]="true"
                (onUpdate)="updateDescription($event)"
                (onInputChange)="updateDescription($event)"
                (isInvalid)="isDescriptionInvalid($event)"
                [placeholder]="T.common.add_description | translate">
              </app-details-editable-field>
            </div>
          </section>
        </ng-template>
      </app-accordion-item-details>
      <app-accordion-item-details [title]="T.common.assign | translate" [expanded]="false">
        <ng-template accordionContent>
          <section class="row col-row-space custom-gutters section-padding">
            <div class="col-12">
              <div class="selection">
                <app-filter-dropdown-new
                [filterByModuleObjectType]="false"
                [filterType]="filterTypes.Owner"
                [appliedFilters]="filters"
                [disabled]="disableOwnersDropdown"
                [disableMargin]="true"
                [typeahead]="true"
                [label]="T.common.assign_owner.many | translate"
                (onFilterUpdate)="handleFilterChange($event)">
                </app-filter-dropdown-new>
              </div>
              <div class="bottom-element d-flex">
                <app-button-transparent
                  size="small"
                  icon="add"
                  [disabled]="disableOwnersDropdown"
                  [text]="T.common.assign_me | translate"
                  (clicked)="setAccountForCurrentOwner()">
                </app-button-transparent>
              </div>
            </div>
            <div class="col-12">
              <app-filter-dropdown-new
              [filterByModuleObjectType]="false"
              [filterType]="filterTypes.User_Group"
              [appliedFilters]="filters"
              [disableMargin]="true"
              [typeahead]="true"
              [label]="T.common.assign_group_s | translate"
              (onFilterUpdate)="handleFilterChange($event)">
              </app-filter-dropdown-new>
            </div>
            <div class="d-flex flex-column col-12 order-md-12">
              <div class="selection">
                <app-filter-dropdown-new
                  [filterByModuleObjectType]="false"
                  [filterType]="filterTypes.Department"
                  [disableMargin]="true"
                  [appliedFilters]="filters"
                  [typeahead]="true"
                  [label]="T.common.assign_item | translate: { item: localisedDepartment }"
                  (onFilterUpdate)="handleFilterChange($event)">
                </app-filter-dropdown-new>
              </div>
              <div class="bottom-element d-flex" *ngIf="employee?.departmentId > 0">
                <app-button-transparent
                  size="small"
                  icon="add"
                  [text]="T.common.assign_my_localisedDepartment | translate: { localisedDepartment: localisedDepartment }"
                  (clicked)="setMyDepartment()"
                ></app-button-transparent>
              </div>
            </div>
          </section>
        </ng-template>
      </app-accordion-item-details>
      <app-accordion-item-details [title]="T.defaultLocalizations.tag.many | translate" [expanded]="false">
        <ng-template accordionContent>
          <section class="row col-row-space custom-gutters section-padding">
            <app-add-modal-tag-groups
              class="col-12"
              [layoutClasses]="'col-md-6 col-12'"
              [showTitle]="false"
              [filters]="filters"
              [tagGroupObjectType]="objectTypes.Task"
              (onFiltersUpdated)="handleFilterChange($event)">
            </app-add-modal-tag-groups>
          </section>
        </ng-template>
      </app-accordion-item-details>
    </app-accordion-details>
  </app-modal-body>

  <app-modal-footer>
    <app-button-transparent
        class="d-none d-lg-block"
        [app-tooltip]="{
          title: T.common.keyboard_shortcuts | translate,
          position: ['top'],
          templateRef: tooltipTemplate
        }"
        [text]="T.common.keyboard_shortcuts | translate"
        icon="keyboard">
      </app-button-transparent>
      <div class="d-flex align-items-center">
        <app-button-rectangle
          class="button d-none d-md-block me-2"
          [fitToContainer]="true"
          size="large"
          [text]="T.common.close | translate"
          buttonTheme="white"
          (clicked)="confirmClose()">
        </app-button-rectangle>
        <app-button-dropdown
          class="button"
          [disabled]="form.invalid || invalidDescription"
          [fitToContainer]="true"
          [selectedOption]="buttonOptions[selectedButtonOption]"
          [options]="buttonOptions"
          (selected)="handleAction($event)">
        </app-button-dropdown>
      </div>
  </app-modal-footer>
  <ng-template #tooltipTemplate>
    <table class="styled-table">
      <tr *ngFor="let keybind of keyboardShortcuts">
        <td>
          <span class="key-shortcut">{{ keybind.key }}</span> -
          <span class="key-description">{{ keybind.description }}</span>
        </td>
      </tr>
    </table>
  </ng-template>
  <ng-template #ratingStarTemplate let-i="index" let-v="value">
    <span class="material-symbols-outlined" [ngStyle]="{ color: i < v ? 'var(--wt-black)' : 'var(--wt-grey-light)' }">
      star
    </span>
  </ng-template>
  <ng-template #loadingTemplate><app-loading [displayLogo]="true"></app-loading></ng-template>
</app-modal>
